const pollReducer = (state, action) => {
  switch (action.type) {
    case 'POLL_LOAD':
      return { ...state, pollProgress: true };
    case 'POLL_SUCCESS':
      return {
        ...state,
        pollProgress: false,
        pollLoaded: true,
        poll: action.poll,
      };
    case 'POLL_ERROR':
      return {
        ...state,
        pollProgress: false,
        pollLoaded: true,
        pollError: action.error,
      };
    case 'POLL_POST_ANSWER':
      return { ...state, pollProgress: true, pollError: null };
    case 'POLL_POST_ANSWER_SUCCESS': {
      const currentCopy = { ...state.poll };
      currentCopy.pollAnswers.push(action.answer);
      return {
        ...state,
        pollProgress: false,
        pollSuccess: true,
        poll: currentCopy,
        pollError: null,
      };
    }
    case 'POLL_POST_ANSWER_ERROR':
      return {
        ...state,
        pollProgress: false,
        pollSuccess: false,
        pollError: action.error,
      };
    default:
      return state;
  }
};

export default pollReducer;
